export default "__VITE_ASSET__MLPb5uSB__"